import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const favoritesSpaceDefaultSortOrder: IOrderClause[] = [Order.asc(OrderKeys.position)];

export const favoritesMixedContentOptions: OptionsDictionary = {
  // Mixed Content does not support relevance
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
  'dateAdded': SortOptions.dateAdded,
  'position': SortOptions.position
};
